import React from 'react'
import SliderBasic from '../../../Components/SliderBasic/SliderBasic'
import { useAuth } from '../../../context/authContext'

function Sliders() {


    const {peliculasRecientementes,dataSeries,misFavoritas}= useAuth()


  return (
    <>
        <SliderBasic
            data={peliculasRecientementes}
            titleSlider={"Peliculas"}
        />
          <SliderBasic
              data={dataSeries}
              titleSlider={"Series"}
  
          />
        {
          misFavoritas.length>5&&(

            <SliderBasic
                data={misFavoritas}
                titleSlider={"Mis favoritas"}
            />
          )
        }
    </>
  )
}

export default Sliders